import { render } from "./orders.vue?vue&type=template&id=a2b4c790"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"

import "./orders.vue?vue&type=style&index=0&id=a2b4c790&lang=css"
script.render = render

export default script